export default __webpack_public_path__ + "static/media/a1.fd6aa461.png";